import { render, staticRenderFns } from "./ArticlesComponent.vue?vue&type=template&id=35cea5a4&"
import script from "./ArticlesComponent.vue?vue&type=script&lang=js&"
export * from "./ArticlesComponent.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesComponent.vue?vue&type=style&index=0&id=35cea5a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports